"use client";

import { memo } from "react";
import { HeroDark } from "@/components/screen/global-components/hero";

const SupportHero = ({}: React.ComponentProps<"section">) => {
  return (
    <HeroDark
      title="How can we help you?"
      description="Get help with our services, existing projects, and more. Contact us by email, phone, or chat 24/7 a day."
    />
  );
};

export default memo(SupportHero);
